import React from 'react';
import { Form, Input } from 'antd';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ResetPasswordFormData } from './types';
import { FormItem, HelperText, ButtonWrapper, PrimaryButton, PasswordInputWrapper, ResponsiveFormWrapper } from '../styles';

interface PasswordResetFormProps {
  control: Control<ResetPasswordFormData, any>;
  errors: FieldErrors<ResetPasswordFormData>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isLoading: boolean;
}

const PasswordResetForm: React.FC<PasswordResetFormProps> = ({
  control,
  errors,
  onSubmit,
  isLoading,
}) => {
  return (
    <ResponsiveFormWrapper>
      <Form layout="vertical" onFinish={onSubmit} size="large">
        <FormItem>
        <Form.Item
          label="New Password"
          validateStatus={errors.password ? 'error' : ''}
          help={errors.password?.message}
          required
        >
          <PasswordInputWrapper>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <Input.Password
                  {...field}
                  placeholder="Enter new password"
                  iconRender={(visible) => (
                    <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
                  )}
                  style={{
                    borderRadius: '8px',
                  }}
                />
              )}
            />
          </PasswordInputWrapper>
        </Form.Item>
        <HelperText>
          Password must be 6-20 characters with uppercase, lowercase, and number
        </HelperText>
      </FormItem>
      
      <FormItem>
        <Form.Item
          label="Confirm New Password"
          validateStatus={errors.confirmPassword ? 'error' : ''}
          help={errors.confirmPassword?.message}
          required
        >
          <PasswordInputWrapper>
            <Controller
              name="confirmPassword"
              control={control}
              render={({ field }) => (
                <Input.Password
                  {...field}
                  placeholder="Confirm new password"
                  iconRender={(visible) => (
                    <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
                  )}
                  style={{
                    borderRadius: '8px',
                  }}
                />
              )}
            />
          </PasswordInputWrapper>
        </Form.Item>
      </FormItem>
      
      <ButtonWrapper>
        <PrimaryButton
          type="primary"
          htmlType="submit"
          block
          loading={isLoading}
        >
          Reset Password
        </PrimaryButton>
      </ButtonWrapper>
    </Form>
    </ResponsiveFormWrapper>
  );
};

export default PasswordResetForm;
